import { Button, Form, Input, Modal } from 'antd';
import React, { useContext, useEffect, useState, useRef } from 'react';
import './formSteps.scss';
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Popup_Toast } from '../../../constants/Popups_Toast';

const OtpVerification = ({ resendClick, resentOtpTriggered }) => {
    const popupContent = Popup_Toast?.MULTI_STEP_FORM?.OTP_LIMIT;
    const navigate = useNavigate();
    const FormData = useContext(MultiStepFormData);
    const maxLength = 6;
    const resentButton = useRef();
    const no = useSelector((state) => state.Login?.user?.phoneNumber)
    const [form] = Form.useForm(); // Form instance
    const [timer, setTimer] = useState(30);
    const [isOtpValid, setIsOtpValid] = useState(true); // State to track if OTP is valid
    const [isInputDisabled, setIsInputDisabled] = useState(false); // State to control input disabled status
    const [resendOtpCount, setResendOtpCount] = useState(0);
    const [otpModal, setOtpModal] = useState(false)
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            setIsOtpValid(false); // Set OTP as invalid when timer reaches 0
            setIsInputDisabled(true); // Disable the input field when timer runs out
            FormData.setFormVerified({
                ...FormData.formVerified,
                [FormData.page]: false
            });

            resentButton.current.classList.add('active');
        }
    }, [timer]);



    const onChange = (e) => {
        let inputValue = e.target.value;
        if (inputValue.length > 0 && inputValue.length === maxLength) {
            if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                e.preventDefault();
                FormData.setFormData((prev) => ({
                    ...prev,
                    otp: e.target.value,
                }));
            }

        }
        form.setFieldsValue({ otp: inputValue }); // Update form field value
    };

    const onFinish = (values) => {
        console.log('Success:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const validateOTP = (_, value) => {
        if (value && value.length === maxLength) {
            FormData.setFormVerified({
                ...FormData.formVerified,
                [FormData.page]: true
            });
            return Promise.resolve();
        } else {
            FormData.setFormVerified({
                ...FormData.formVerified,
                [FormData.page]: false
            });
            // return Promise.reject('OTP must be exactly 6 numbers!');
        }
    };

    const handleCancel = () => {
        setOtpModal(false)
        window.location.href = '/login';
    }

    useEffect(() => {
        if (resentOtpTriggered) {
            setTimer(30);
        }
    }, [resentOtpTriggered])
    return (
        <>
            <div style={{ width: '100%', margin: 'auto' }} className='text-center'>
                <div className="otp_note sm">
                    An OTP has been sent to <span className='text_red'>+91 {no}</span><br></br>Please enter the OTP to proceed.
                </div>
                <Form
                    form={form} // Pass the form instance
                    initialValues={{
                        otp: FormData.formData.otp
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete='off'
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}>
                    <div style={{ maxWidth: '509px', margin: 'auto' }}>
                        {/* <label htmlFor='' className='text_red d-block sm'>
                            6 Digit OTP
                        </label> */}
                        <Form.Item
                            name='otp'
                            rules={[
                                {
                                    required: true,
                                    // message: 'Please input your OTP!'
                                },
                                {
                                    validator: validateOTP
                                }
                            ]}>
                            <Input
                                maxLength={6} // Maximum length with spaces
                                onChange={onChange}
                                value={FormData.formData.otp} // Use directly from form data
                                style={{
                                    margin: '10px auto',
                                    color: '#9E9E9E',
                                    textAlign: 'center',
                                    boxShadow: 'none',
                                    outline: 'none',
                                    height: 'calc(1vw + 38px)'
                                }}
                                type='text'
                                placeholder='- - - - - -'
                                disabled={isInputDisabled} // Disable the input field based on state
                                onKeyDown={(e) => {
                                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>
                        <div style={{ marginTop: 'calc(1.5vw + 40px)' }}>
                            <span className='d-block text_red' style={{ marginBottom: '20px' }}>
                                {timer !== 0 && (
                                    <>Expect OTP in <span className='otp_counter'><strong>{timer}s</strong></span></>
                                )}
                            </span>
                            {timer === 0 && (
                                <Button
                                    ref={resentButton}
                                    className='resend_btn wide sm'
                                    style={{ borderRadius: "20px" }}
                                    type='secondary'
                                    disabled={timer !== 0}
                                    onClick={() => {
                                        setResendOtpCount(resendOtpCount + 1);
                                        setIsInputDisabled(false);
                                        resentButton.current.classList.remove('active');

                                        // Clear the OTP field when the button is clicked
                                        form.setFieldsValue({ otp: '' });

                                        if (resendOtpCount < 3) { // Changed from <= to < to allow 3 sends
                                            resendClick(true);
                                        } else {
                                            setOtpModal(true);
                                        }
                                    }}
                                >
                                    Resend OTP
                                </Button>
                            )}

                        </div>
                    </div>
                </Form>
                <Modal className=' center_modal sm_modal work_modal' open={otpModal} onOk={handleCancel} onCancel={handleCancel} footer={<div className='text-center'><Button type='primary' className='wide' onClick={() => {
                    setTimeout(() => {
                        handleCancel()
                        navigate('/login')
                    }, 400)
                }}>Ok</Button>  <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
                        Close
                    </Button></div>}>
                    <p style={{ lineHeight: '1.5' }}><span className='text_red semibold'>{popupContent?.content?.title}.</span> {popupContent?.content?.description}</p>
                </Modal>
            </div>
        </>
    );
};

export default OtpVerification;
